import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ProductAvailability from './ProductAvailability'

import { fetchAvailability, selectAvailabilityBySku } from 'Catalog/Availability/ducks'

class ProductAvailabilityContainer extends Component {
  handleAvailabilityUpdate () {
    const { sku, originalId, vendorId, loadAvailability, isPriceUpdated, isLoading } = this.props

    !isPriceUpdated && !isLoading && loadAvailability(sku, originalId, vendorId)
  }

  componentDidMount () {
    this.handleAvailabilityUpdate()
    this.setState({ changeContext: this.props.changeContext })
  }

  componentDidUpdate () {
    this.handleAvailabilityUpdate()
  }

  render () {
    const { isLoading, isAvailable, price, changeContext } = this.props
    return (
      <ProductAvailability
        isLoading={isLoading}
        isAvailable={isAvailable}
        price={price}
        changeContext={changeContext}
      />
    )
  }
}

ProductAvailabilityContainer.propTypes = {
  sku: PropTypes.string.isRequired,
  originalId: PropTypes.string.isRequired,
  vendorId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  loadAvailability: PropTypes.func,
  isAvailable: PropTypes.bool,
  price: PropTypes.object,
  isPriceUpdated: PropTypes.bool,
  changeContext: PropTypes.bool
}

ProductAvailabilityContainer.defaultProps = {
  isPriceUpdated: false
}

const mapStateToProps = (state, props) => selectAvailabilityBySku(state, props) || {}

const mapDispatchToProps = dispatch => ({
  loadAvailability: (sku, originalId, vendorId) =>
    dispatch(fetchAvailability(sku, originalId, vendorId))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductAvailabilityContainer)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/ProductAvailabilityContainer.js